import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {BboZawodnik} from '../classess/bbo-zawodnik';
import {Observable, throwError} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {Zawodnik} from '../classess/zawodnik';
import {Wiadomosc} from '../classess/widomosc';


@Injectable({
  providedIn: 'root'
})
export class WiadomoscService {

  path = 'http://ozbs.olsztyn.pl/services';
  wiadomosci: Wiadomosc[];
  baseUrl = 'https://ozbs.olsztyn.pl/services/wiadomosc.php';

  constructor(private http: HttpClient) { }

  getAll(): Observable<Wiadomosc[]> {
    return this.http.get(`${this.baseUrl}`).pipe(
      map((res) => {
        this.wiadomosci = res['data'];
        return this.wiadomosci;
      }),
      catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    console.log(error);
    return throwError('Error! something went wrong.');
  }

}
